import { createFileRoute } from "@tanstack/react-router";
import { ReferralLandingPage } from "@/features/referral-landing/ReferralLandingPage";

/** Public referral landing for one client's link (/p/referral/<workspace>/<code>). Sits outside the _app layout, so there is
 *  no app shell, like the other public pages. */
export const Route = createFileRoute("/p/referral/$ws/$code")({
  component: ReferralRoute,
});

function ReferralRoute() {
  const { ws, code } = Route.useParams();
  return <ReferralLandingPage ws={ws} code={code} />;
}
